import { Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { LogoutComponent } from '@pages/logout/logout.component';
import {NotFoundComponent} from '@pages/not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'oidc/callback',
    component: OktaCallbackComponent,
  },
  {
    path: 'loggedout',
    component: LogoutComponent,
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'protected',
    pathMatch: 'full',
  },
  {
    path: 'protected',
    loadChildren: () =>
      import('./protected.routes').then((m) => m.PROTECTED_ROUTES),
    canActivate: [OktaAuthGuard],
    data: {
      onAuthRequired: (oktaAuth: any) => {
        oktaAuth.signInWithRedirect();
      },
    },
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];
